import moment from "moment";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  commonConstants,
  schedulePaymentsConstants,
} from "../../../_redux/_constants";
import NumberFormatter from "../../../_helpers/numberFormatter";
import { CloseRedCircle } from "../../../styles/img/svg/CloseRedCircle";
import {
  clearChangeIterationStatusSuccess,
  setActiveView,
} from "../../../_redux/_actions";

export const UiScheduleIterationDetail = ({ onStopClick, isStopLoading }) => {
  const dispatch = useDispatch();
  const {
    selectedIterationData,
    schedulePaymentsDetails,
    changeIterationStatusSuccess,
    scheduleDetailActiveTab,
  } = useSelector((state) => state.schedulePayments);

  useEffect(() => {
    return () => {
      dispatch(clearChangeIterationStatusSuccess());
    };
  }, []);

  useEffect(() => {
    if (changeIterationStatusSuccess) {
      dispatch(
        setActiveView(
          schedulePaymentsConstants.ACTIVE_VIEW_SCHEDULE_PAYMENT_ITERATION_STOP,
        ),
      );
    }
  }, [changeIterationStatusSuccess]);

  return (
    <div className="df-schedule-summary-card">
      <div className="df-schedule-summary-card__row">
        <span>From Account:</span>
        <span>{schedulePaymentsDetails?.fromAccountNo}</span>
      </div>

      <div className="df-schedule-summary-card__divider" />

      <div className="df-schedule-summary-card__row">
        <span>To Account:</span>
        <span>
          {schedulePaymentsDetails?.toAccountNo ||
            schedulePaymentsDetails?.payeeAccountNo}
        </span>
      </div>

      {schedulePaymentsDetails?.scheduledPaymentType ===
        schedulePaymentsConstants.SCHEDULED_PAYMENT_TYPE_TRANSFER && (
        <>
          <div className="df-schedule-summary-card__row">
            <span>Account Name:</span>
            <span>{schedulePaymentsDetails?.beneficiaryName}</span>
          </div>

          <div className="df-schedule-summary-card__row">
            <span>Bank Name:</span>
            <span>{schedulePaymentsDetails?.bankDescription}</span>
          </div>
        </>
      )}

      {schedulePaymentsDetails?.scheduledPaymentType ===
        schedulePaymentsConstants.SCHEDULED_PAYMENT_TYPE_BILL && (
        <div className="df-schedule-summary-card__row">
          <span>Biller Name:</span>
          <span>{schedulePaymentsDetails?.payeeName}</span>
        </div>
      )}

      <div className="df-schedule-summary-card__divider" />

      <div className="df-schedule-summary-card__row">
        <span>Schedule Ref:</span>
        <span>{schedulePaymentsDetails?.scheduledReference}</span>
      </div>

      <div className="df-schedule-summary-card__row">
        <span>Schedule Date:</span>
        <span>
          {moment(selectedIterationData?.iterationDate).format(
            commonConstants.COMMON_DATE_FORMAT_DD_MM_YYYY,
          )}
        </span>
      </div>

      {schedulePaymentsDetails?.references && (
        <div className="df-schedule-summary-card__row">
          <span>My Ref:</span>
          <span>{schedulePaymentsDetails?.references}</span>
        </div>
      )}

      {schedulePaymentsDetails?.scheduledPaymentName && (
        <div className="df-schedule-summary-card__row">
          <span>Schedule Payment Name:</span>
          <span>{schedulePaymentsDetails?.scheduledPaymentName}</span>
        </div>
      )}

      <div className="df-schedule-summary-card__divider" />

      <div className="df-schedule-summary-card__row">
        <span>Amount:</span>
        <span>
          {NumberFormatter(
            schedulePaymentsDetails?.scheduledPaymentType ===
            schedulePaymentsConstants.SCHEDULED_PAYMENT_TYPE_BILL ? schedulePaymentsDetails?.customerNearestChargeAmountInBaseCur : schedulePaymentsDetails?.originalAmount,
            schedulePaymentsDetails?.scheduledPaymentType ===
            schedulePaymentsConstants.SCHEDULED_PAYMENT_TYPE_BILL ? schedulePaymentsDetails?.currencyBeforeConvert : schedulePaymentsDetails?.currencyAfterConvert,
          )}
        </span>
      </div>

      <div className="df-schedule-summary-card__row">
        <span>Status:</span>

        {selectedIterationData?.status?.name ? (
          <>
            {selectedIterationData?.status?.name ===
              schedulePaymentsConstants.SCHEDULE_PAYMENTS_RECURRING_TXN_STATUS_SUCCESS && (
              <span>Success</span>
            )}
            {selectedIterationData?.status?.name ===
              schedulePaymentsConstants.SCHEDULE_PAYMENTS_RECURRING_TXN_STATUS_FAIL && (
              <span>Failed</span>
            )}
          </>
        ) : (
          <>
            {selectedIterationData?.iterationStatus?.name ===
              schedulePaymentsConstants.SCHEDULE_PAYMENTS_RECURRING_TXN_STATUS_ACTIVE && (
              <span>Active</span>
            )}
            {selectedIterationData?.iterationStatus?.name ===
              schedulePaymentsConstants.SCHEDULE_PAYMENTS_RECURRING_TXN_STATUS_STOPPED && (
              <span>Stopped</span>
            )}
            {selectedIterationData?.iterationStatus?.name ===
              schedulePaymentsConstants.SCHEDULE_PAYMENTS_RECURRING_TXN_STATUS_COMPLETED && (
              <span>Completed</span>
            )}
          </>
        )}
      </div>

      {selectedIterationData?.iterationStatus?.name ===
        schedulePaymentsConstants.SCHEDULE_PAYMENTS_RECURRING_TXN_STATUS_ACTIVE &&
        scheduleDetailActiveTab ===
          schedulePaymentsConstants.SCHEDULE_DETAIL_TAB_UPCOMING_SCHEDULES && (
          <>
            <div className="df-schedule-summary-card__divider" />

            <button
              type="button"
              className="df-schedule-summary-card__stop-btn"
              onClick={onStopClick}
              disabled={isStopLoading}
            >
              <span className="df-schedule-summary-card__stop-icon">
                <CloseRedCircle />
              </span>

              <span>Stop Schedule</span>
            </button>
          </>
        )}

      {selectedIterationData?.failureReason && selectedIterationData?.status?.name ===
              schedulePaymentsConstants.SCHEDULE_PAYMENTS_RECURRING_TXN_STATUS_FAIL && (
        <> 
          <div className="df-schedule-summary-card__divider" />

          <p className="df-schedule-summary-card__error">
            {selectedIterationData.failureReason}
          </p>
        </>
      )}

      {/* will be used for failed payments 
      <div className="df-schedule-summary-card__divider" /> */}

      {/* <div className="df-schedule-status-wrap df-schedule-status-wrap--retry df-schedule-status-wrap__retry-btn">
        <button
          type="button"
          className="df-schedule-retry-btn"
          onClick={() => {}}
        >         
          <RetryIcon /><span>Retry</span>
        </button>
      </div> */}
    </div>
  );
};
